import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "../shared/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please complete the required fields.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setDone(true);
      toast.success("Report requested — we'll be in touch shortly.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="arcsec">
      <div className="arc top" />
      <div className="wrap">
        <Reveal className="cta2" tag="div">
          <h2>Book Your <span className="g">Complimentary Gap Analysis</span></h2>
          <p>See exactly where your buildings are losing energy — before you invest a penny.</p>

          {done ? (
            <div className="cok" data-testid="contact-success">
              <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#22A9E0" strokeWidth="2" style={{ margin: "0 auto" }}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
              <div className="h">Request received.</div>
              <p>Thank you — our team will reach out to arrange your free gap analysis, and a confirmation is on its way to your inbox.</p>
            </div>
          ) : (
            <form className="cform" onSubmit={submit} data-testid="contact-form">
              <div className="row">
                <div><label>Name *</label><input data-testid="contact-name" value={form.name} onChange={set("name")} placeholder="Jane Doe" /></div>
                <div><label>Company</label><input data-testid="contact-company" value={form.company} onChange={set("company")} placeholder="Acme Estates" /></div>
              </div>
              <div><label>Email *</label><input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} placeholder="jane@company.com" /></div>
              <div><label>Tell us about your estate *</label><textarea data-testid="contact-message" rows={4} value={form.message} onChange={set("message")} placeholder="Number of sites, sectors, current challenges…" /></div>
              <button className="btn" type="submit" disabled={loading} data-testid="contact-submit">
                {loading ? "Sending…" : "Book My Complimentary Gap Analysis"}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
